import { Grid, Typography } from "@mui/material";
import { useSession } from "providers/SessionProvider";

import {
  buildPreparationDateRangeLabel,
  buildPreparationVehiclesLabel,
  getOrdersPreparationClientLabels,
  getOrdersPreparationCreatorLabels,
  getOrdersPreparationStoreLabels,
  getOrdersPreparationTotalBoxes,
  getOrdersPreparationTotalUnits,
} from "helpers/orderPreparationReports";
import { Order } from "types";

type Props = {
  title: string;
  subtitle: string;
  orders: Order[];
  showClients?: boolean;
};

export default function OrderPreparationPrintHeader({
  title,
  subtitle,
  orders,
  showClients = false,
}: Props) {
  const { stores, users } = useSession();
  const generatedAt = new Date().toLocaleString("es-AR");
  const orderDateRangeLabel = buildPreparationDateRangeLabel(orders);
  const vehicleLabel = buildPreparationVehiclesLabel(orders);
  const totalBoxes = getOrdersPreparationTotalBoxes(orders);
  const totalUnits = getOrdersPreparationTotalUnits(orders);
  const clientLabels = showClients ? getOrdersPreparationClientLabels(orders) : null;
  const creatorLabels = getOrdersPreparationCreatorLabels(orders, users);
  const storeLabels = getOrdersPreparationStoreLabels(orders, stores);

  return (
    <Grid container spacing={1.5} sx={{ color: "black", pt: 1 }}>
      <Grid item xs={12}>
        <Typography variant="h5" fontWeight="bold">
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2">{subtitle}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">
          <b>Pedidos:</b> {orders.length}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">
          <b>Fechas de pedido:</b> {orderDateRangeLabel}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">
          <b>Vehiculo(s):</b> {vehicleLabel}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">
          <b>Cant. Total:</b> {totalBoxes}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">
          <b>Total unidad:</b> {totalUnits}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">
          <b>Creado por:</b> {creatorLabels}
        </Typography>
      </Grid>
      <Grid item xs={showClients ? 6 : 12}>
        <Typography variant="body2">
          <b>Depósito(s):</b> {storeLabels}
        </Typography>
      </Grid>
      {showClients && (
        <Grid item xs={6}>
          <Typography variant="body2">
            <b>Cliente(s):</b> {clientLabels}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography variant="body2">
          <b>Generado:</b> {generatedAt}
        </Typography>
      </Grid>
    </Grid>
  );
}
